import React from 'react';
import PropTypes from 'prop-types';

import LocalizationConsumer from '../../../l10n/localization-context';

import './insert-anchor.less';

const InsertAnchor = ({ value, onChange }) => (
  <div className="insertLinkAnchorContainer">
    <table className="formStructureTable">
      <tbody>
        <tr>
          <td valign="top" className="propertiesListContainer">
            <table align="center" cellSpacing="0" cellPadding="0">
              <tbody>
                <tr>
                  <td className="propertyLabel">
                    <LocalizationConsumer id="insert-anchor.label" />
                  </td>
                  <td className="propertyControl">
                    <input
                      type="text"
                      onChange={e => onChange(e.target.value)}
                      maxLength="1024"
                      value={value}
                    />
                  </td>
                </tr>
                <tr>
                  <td />
                  <td>
                    <div className="inputTooltip">
                      <LocalizationConsumer id="insert-anchor.tip" />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
);

InsertAnchor.propTypes =
{
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

InsertAnchor.defaultProps =
{
  value: ''
};

export default InsertAnchor;